module.exports = __webpack_public_path__ + "img/main.507c4081.png";